import { createSlice } from "@reduxjs/toolkit";

export const dateTimeFormatSlice = createSlice({
  name: "dateTimeFormat",
  initialState: {
    getDateTimeFormatResult: false,
    getDateTimeFormatLoading: false,
    getDateTimeFormatError: false,
  },
  reducers: {
    dateTimeFormatReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_DATETIMEFORMAT":
          return {
            ...state,
            getDateTimeFormatResult: payload.data,
            getDateTimeFormatLoading: payload.loading,
            getDateTimeFormatError: payload.error,
          };
        default:
          return state;
      }
    },
  },
});

export const { dateTimeFormatReducers } = dateTimeFormatSlice.actions;

export default dateTimeFormatSlice.reducer;
